<!-- 这是左边第二个echart的父组件 -->
<template>
  <div id="left-2">
    <div class="title">
      <div class="header"></div>
      <div class="bg" :class="isActive==1?'active':''" @click="handleActive(1)">城市营业额</div>
      <div class="bg" :class="isActive==2?'active':''" @click="handleActive(2)">城市端口数</div>
    </div>
    <div class="com-chart" ref="seller_ref"></div>
  </div>
</template>
<script>
export default {
  props: ["level", "regionId", "deviceType"],
  data() {
    return {
      sellerChart: null,
      saleNummber: [], // 营业额
      allData: null,
      barData: [], //该数据根据tab切换而变，营业额 turnoverTotals||端口数 socketTotals
      isActive: 1,
      unit: "元",
    };
  },
  mounted() {
    this.initChart();
    // this.handleLoop();
    this.getData();
  },
  methods: {
    //标题背景的切换
    handleActive(val) {
      if (val == 1) {
        this.isActive = 1;
        this.unit = "元";
        this.getData();
      } else if (val == 2) {
        this.isActive = 2;
        this.unit = "个";
        this.getData();
      }
    },
    // 数据切换
    handleLoop() {
      var start = 1;
      setInterval(() => {
        this.handleActive(start);
        start = start + 1;
        if (start > 2) {
          return (start = 1);
        }
      }, 3000);
    },
    // 初始化echarts实例对象
    initChart() {
      this.sellerChart = this.$echarts.init(this.$refs.seller_ref);
    },
    // 获取服务器数据
    getData() {
      // 1营业额、2端口数
      if (this.isActive == 1) {
        this.$http({
          url: this.$http.adornUrl("/admin/api/busi/stat/turnover"),
          method: "get",
          params: this.$http.adornParams({
            deviceType: this.deviceType,
            regionId: this.regionId,
            level: this.level,
            sortType: 1,
          }),
        }).then(({ data }) => {
          console.log(data,'营业额打印11111111')
          if (data.code == 0) {
            this.allData = data.data;
            this.barData = data.data.provinceTurnoverVo;
            this.updateChart();
            // if (data.data.provinceTurnoverVo.length == 0) {
            //   this.$http({
            //     url: this.$http.adornUrl("/admin/api/busi/stat/turnover"),
            //     method: "get",
            //     params: this.$http.adornParams({
            //       deviceType: this.deviceType,
            //       regionId: "",
            //       level: 0,
            //       sortType: 1,
            //     }),
            //   }).then(({ data }) => {
            //     if (data.code == 0) {
            //       this.allData = data.data;
            //       this.barData = data.data.provinceTurnoverVo;
            //       this.updateChart();
            //     }
            //   });
            // }
          }
        });
      } else if (this.isActive == 2) {
        this.$http({
          url: this.$http.adornUrl("/admin/api/busi/stat/socket"),
          method: "get",
          params: this.$http.adornParams({
            deviceType: this.deviceType,
            regionId: this.regionId,
            level: this.level,
            sortType: 3,
          }),
        }).then(({ data }) => {
          console.log(data,'端口数打印11111111')
          if (data.code == 0) {
            this.allData = data.data;
            this.barData = data.data.provinceSocketVoList;
            this.updateChart();
            // if (data.data.provinceSocketVoList.length == 0) {
            //   this.$http({
            //     url: this.$http.adornUrl("/admin/api/busi/stat/socket"),
            //     method: "get",
            //     params: this.$http.adornParams({
            //       deviceType: this.deviceType,
            //       regionId: "",
            //       level: 0,
            //       sortType: 3,
            //     }),
            //   }).then(({ data }) => {
            //     if (data.code == 0) {
            //       this.allData = data.data;
            //       this.barData = data.data.provinceSocketVoList;
            //       this.updateChart();
            //     }
            //   });
            // }
          }
        });
      }
    },
    // 更新图表
    updateChart() {
      var attackSourcesColor = [
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 1, color: "#EB3B5A" },
          { offset: 0, color: "#FE9C5A" },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 1, color: "#FA8231" },
          { offset: 0, color: "#FFD14C" },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 1, color: "#F7B731" },
          { offset: 0, color: "#FFEE96" },
        ]),
        new this.$echarts.graphic.LinearGradient(0, 1, 1, 1, [
          { offset: 1, color: "#395CFE" },
          { offset: 0, color: "#2EC7CF" },
        ]),
      ];
      var attackSourcesColor1 = [
        "#EB3B5A",
        "#FA8231",
        "#F7B731",
        "#3860FC",
        "#1089E7",
        "#F57474",
        "#56D0E3",
        "#1089E7",
        "#F57474",
        "#1089E7",
        "#F57474",
        "#F57474",
      ];
      var newRegionNames = this.allData.regionNames;
      function contains(arr, dst) {
        var i = arr.length;
        while ((i -= 1)) {
          if (arr[i] == dst) {
            return i;
          }
        }
        return false;
      }
      function attackSourcesDataFmt(sData) {
        var sss = [];
        sData.forEach(function (item, i) {
          let itemStyle = {
            color: i > 3 ? attackSourcesColor[3] : attackSourcesColor[i],
          };
          sss.push({
            value: item.value,
            itemStyle: itemStyle,
          });
        });
        return sss;
      }

      var salvProMax = []; //背景按最大值
      for (let i = 0; i < this.barData.length; i++) {
        salvProMax.push(this.barData[0].value);
      }

      const option = {
        grid: {
          left: "-10%",
          right: "0%",
          bottom: "0%",
          top: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisPointer: {
              label: {
                show: true,
              },
            },
            data: this.allData.regionNames,
            axisLabel: {
              margin: 30,
              fontSize: 12,
              align: "left",
              color: "#000",
              rich: {
                nt1: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[0],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [2, 1, 2, 1],
                  // padding:[0,0,2,0],
                },
                nt2: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[1],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [2, 1, 2, 1],
                },
                nt3: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[2],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [3, 1, 2, 1],
                },
                nt: {
                  color: "#fff",
                  backgroundColor: attackSourcesColor1[3],
                  width: 13,
                  height: 13,
                  fontSize: 12,
                  align: "center",
                  borderRadius: 1,
                  lineHeight: "5",
                  padding: [3, 1, 2, 1],
                },
              },
              formatter: function (value, index) {
                index = contains(newRegionNames, value) + 1;
                if (index - 1 < 3) {
                  return ["{nt" + index + "|" + index + "}"].join("\n");
                } else {
                  return ["{nt|" + index + "}"].join("\n");
                }
              },
            },
          },
          {
            type: "category",
            inverse: true,
            axisTick: "none",
            axisLine: "none",
            show: true,
            axisLabel: {
              textStyle: {
                color: "#fff",
                fontSize: "12",
              },
              formatter: (val) => {
                return `${val}` + this.unit;
              },
            },
            data: attackSourcesDataFmt(this.barData),
          },
          {
            //省份名称
            type: "category",
            offset: -10,
            position: "left",
            axisLabel: {
              color: `#00ECFC`,
              fontSize: 12,
            },
            axisLine: {
              show: false,
            },
            inverse: false,
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              color: ["#fff"],
              align: "left",
              verticalAlign: "bottom",
              lineHeight: 24,
              fontSize: 12,
            },
            data: this.allData.regionNames.reverse(),
          },
        ],
        series: [
          {
            zlevel: 1,
            name: "",
            type: "bar",
            barWidth: "10px",
            animationDuration: 1500,
            data: attackSourcesDataFmt(this.barData),
            itemStyle: {
              normal: {
                barBorderRadius: 10,
              },
            },
          },
          {
            name: "",
            type: "bar",
            barWidth: 10,
            barGap: "-100%",
            barCategoryGap: "0%",
            data: salvProMax,
            itemStyle: {
              normal: {
                color: "#05325F",
                // width:"100%",
                fontSize: 14,
                barBorderRadius: 10,
              },
            },
          },
        ],
        // option结尾的大括号
      };
      this.sellerChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.com-chart {
  width: 100%;
  height: 342px;
  overflow: hidden;
}
#left-2 {
  width: 100%;
  // height: 288px;
  height: 374px;
  // border: 1px solid red;
  margin: 30px 0;
  .title {
    // width: 100%;
    height: 32px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    display: flex;
    .header {
      width: 30px;
      height: 20px;
      background-image: url("../../assets/left-2-title.png");
      background-size: 30px 20px;
    }
    .bg {
      width: 130px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-image: url("../../assets/left-2-title-normal.png");
      background-size: 130px 30px;
    }
    .bg:nth-child(2) {
      margin-left: -25px;
    }
    .bg:nth-child(3) {
      margin-left: -18px;
    }
    .bg:hover {
      background-image: url("../../assets/left-2-big-title-active.png");
      background-size: 130px 30px;
      cursor: pointer;
    }
    .active {
      background-image: url("../../assets/left-2-big-title-active.png");
      background-size: 130px 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index/left-2.vue